/** 温泉民宿宝栄丸 — SEO定数 */

export const SITE_NAME = "温泉民宿宝栄丸";

export const SITE_TITLE =
  "温泉民宿宝栄丸｜静岡・東伊豆町稲取の海を望む湯の宿";

export const SITE_DESCRIPTION =
  "静岡県東伊豆町稲取の温泉民宿「宝栄丸」。全3室の小さな宿で、稲取の海を眺めながら天然温泉に浸かる癒しのひとときを。伊豆稲取駅より徒歩15分。ご予約はお電話（0557-95-1813）で。";

export const SITE_KEYWORDS = [
  "温泉民宿宝栄丸",
  "宝栄丸",
  "稲取",
  "東伊豆",
  "伊豆",
  "温泉民宿",
  "温泉宿",
  "静岡",
  "伊豆稲取",
  "海一望",
  "露天風呂",
].join(",");

/** OGP / シェア用メイン画像（ヒーロー風景） */
export const OG_IMAGE =
  "https://storage.readdy-site.link/project_files/b101d8e3-eb8f-4b23-a967-4f4a49b8c766/4cb340a6-58b7-492c-8666-d84847ba489d_scenery.png?v=1f8215f477d3acf19dbf686edcce640d";

export const LOGO_IMAGE =
  "https://storage.readdy-site.link/project_files/b101d8e3-eb8f-4b23-a967-4f4a49b8c766/ec3f985d-0f8e-4388-91aa-732955220d2f_logo.png?v=4e906732bd7f67cbda67b434e6bd272b";

export const BUSINESS = {
  name: SITE_NAME,
  telephone: "+81-557-95-1813",
  telephoneDisplay: "0557-95-1813",
  postalCode: "413-0411",
  addressRegion: "静岡県",
  addressLocality: "賀茂郡東伊豆町",
  streetAddress: "稲取965",
  addressCountry: "JP",
  latitude: 34.8167,
  longitude: 139.0417,
  checkinTime: "15:00",
  checkoutTime: "10:00",
  numberOfRooms: 3,
  priceRange: "¥10,000〜",
} as const;

export function buildLodgingJsonLd(siteUrl?: string) {
  const url = siteUrl?.replace(/\/$/, "") || undefined;

  return {
    "@context": "https://schema.org",
    "@type": "LodgingBusiness",
    "@id": url ? `${url}/#business` : undefined,
    name: BUSINESS.name,
    alternateName: "宝栄丸",
    description: SITE_DESCRIPTION,
    url: url || undefined,
    telephone: BUSINESS.telephone,
    image: [OG_IMAGE, LOGO_IMAGE],
    logo: LOGO_IMAGE,
    priceRange: BUSINESS.priceRange,
    checkinTime: BUSINESS.checkinTime,
    checkoutTime: BUSINESS.checkoutTime,
    numberOfRooms: BUSINESS.numberOfRooms,
    address: {
      "@type": "PostalAddress",
      postalCode: BUSINESS.postalCode,
      addressRegion: BUSINESS.addressRegion,
      addressLocality: BUSINESS.addressLocality,
      streetAddress: BUSINESS.streetAddress,
      addressCountry: BUSINESS.addressCountry,
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: BUSINESS.latitude,
      longitude: BUSINESS.longitude,
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "00:00",
      closes: "23:59",
    },
    amenityFeature: [
      { "@type": "LocationFeatureSpecification", name: "天然温泉", value: true },
      { "@type": "LocationFeatureSpecification", name: "無料駐車場", value: true },
      { "@type": "LocationFeatureSpecification", name: "Wi-Fi", value: true },
    ],
    sameAs: [] as string[],
  };
}
